<template>
  <div class="errorOTA">
    <div class="title">{{ $t("pageTitle") }}</div>
    <div class="content">
      <img src="../../assets/images/noData.png" alt="" />
      <div class="desc">{{ $t("browserUnsupported") }}</div>
    </div>

    <div class="tips">
      <div class="line"></div>
      <div class="t">{{ $t("openWithBrowsers") }}</div>
      <div class="line"></div>
    </div>

    <div class="items">
      <div class="item">
        <img src="../../assets/images/google.png" alt="" />
        <div class="label">Google</div>
        <div class="num">
          {{ $t("browserVersionGreaterThan", { version: 89 }) }}
        </div>
      </div>
      <div class="item" v-show="!isMac">
        <img src="../../assets/images/opera.png" alt="" />
        <div class="label">Opera</div>
        <div class="num">
          {{ $t("browserVersionGreaterThan", { version: 76 }) }}
        </div>
      </div>
      <div class="item">
        <img src="../../assets/images/edge.png" alt="" />
        <div class="label">Edge</div>
        <div class="num">
          {{ $t("browserVersionGreaterThan", { version: 89 }) }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.errorOTA {
  width: 792px;
  padding: 42px 0;
  box-sizing: border-box;
  margin-left: 50%;
  transform: translateX(-50%);

  .title {
    font-size: 42px;
    font-weight: 600;
    text-align: center;
  }

  .content {
    background: rgba(252, 252, 253, 1);
    border: 0.76px solid rgba(242, 243, 249, 1);
    border-radius: 0.76px;
    padding: 38px 0px 38px 0px;
    width: 100%;
    height: 362px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 72px;
    margin-left: 50%;
    transform: translateX(-50%);

    img {
      width: 198px;
      height: 198px;
    }

    .desc {
      font-size: 28px;
      font-weight: 500;
      line-height: 36px;
      text-align: center;
      margin-top: 16px;
    }
  }

  .tips {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 72px;

    .t {
      font-size: 20px;
      font-weight: 400;
      line-height: 23.8px;
      margin: 0 2px;
      color: rgba(101, 101, 101, 1);
    }

    .line {
      width: 72px;
      height: 1px;
      background-color: rgba(229, 230, 235, 1);
    }
  }

  .items {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 48px;

    .item {
      margin-right: 80px;

      &:last-child {
        margin-right: 0px;
      }

      img {
        width: 120px;
        height: 120px;
      }

      .label {
        font-size: 20px;
        font-weight: 500;
        line-height: 34px;
        text-align: center;
        color: rgba(80, 80, 80, 1);
      }

      .num {
        font-size: 16px;
        font-weight: 400;
        line-height: 27px;
        text-align: center;
        color: rgba(130, 130, 130, 1);
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    isMac: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
